import { render, staticRenderFns } from "./BiRideLogin.vue?vue&type=template&id=4238f2ca&scoped=true"
import script from "./BiRideLogin.vue?vue&type=script&lang=js"
export * from "./BiRideLogin.vue?vue&type=script&lang=js"
import style0 from "./BiRideLogin.vue?vue&type=style&index=0&id=4238f2ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238f2ca",
  null
  
)

export default component.exports